<template>
    <view class="loading-wrapper">
        <view class="uni-async-loading"><text class="uni-loading"></text></view>
    </view>
</template>

<style lang="scss">
    .loading-wrapper {
        height: 100vh;
        overflow: hidden;
        width: 100vw;
        font-size: 24px;
        background: url(@/static/loginBg.png) no-repeat center center;
        background-size: cover;
    }
</style>
